/**
 * Financial Inputs Router Component
 * Routes to the correct input component based on selected valuation method
 */
import React from 'react';
import PropTypes from 'prop-types';
import NAVInputs from './NAVInputs';
import DCFInputs from './DCFInputs';
import CapitalizationInputs from './CapitalizationInputs';
import StandardInputs from './StandardInputs';

const FinancialInputs = ({
  method,
  formData,
  onInputChange,
  onShowHelp,
  setFormData,
  formatNumberWithCommas
}) => {
  // Render appropriate input component based on method
  if (method === 'nav') {
    return (
      <NAVInputs
        formData={formData}
        onInputChange={onInputChange}
        onShowHelp={onShowHelp}
        formatNumberWithCommas={formatNumberWithCommas}
      />
    );
  }

  if (method === 'dcf') {
    return (
      <DCFInputs
        formData={formData}
        onInputChange={onInputChange}
        onShowHelp={onShowHelp}
        setFormData={setFormData}
        formatNumberWithCommas={formatNumberWithCommas}
      />
    );
  }

  if (method === 'capitalization') {
    return (
      <CapitalizationInputs
        formData={formData}
        onInputChange={onInputChange}
        onShowHelp={onShowHelp}
        setFormData={setFormData}
        formatNumberWithCommas={formatNumberWithCommas}
      />
    );
  }

  if (method === 'cca' || method === 'manual') {
    return (
      <StandardInputs
        formData={formData}
        onInputChange={onInputChange}
        onShowHelp={onShowHelp}
        setFormData={setFormData}
        formatNumberWithCommas={formatNumberWithCommas}
      />
    );
  }

  // Fallback - render nothing if method not recognized
  return null;
};

FinancialInputs.propTypes = {
  method: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onShowHelp: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired,
  formatNumberWithCommas: PropTypes.func.isRequired
};

export default FinancialInputs;
